// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__hwVJy","box":"WorkspacesBox_box__O8TpK","node":"WorkspacesBox_node__2aQUK"};